import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Translation } from '~translations/models/translation.model';

@Injectable({
  providedIn: 'root'
})

export class STIL_LanguageTranslationDataService {
  private http = inject(HttpClient);


  create(translation: Translation): Observable<Translation> {
    return this.http.post<Translation>(`stilLanguageTranslation/create`, translation);
  }

  edit(data: Translation): Observable<Translation> {
    const body = {
      ...data,
      languageTranslationID: data.ID
    };
    return this.http.put<Translation>(`stilLanguageTranslation/edit`, body);
  }

  delete(languageTranslationID: number) {
    const params = { languageTranslationID };
    return this.http.delete(`stilLanguageTranslation/delete`, { params: params as any });
  }

  getRecordsForParentID(parentID: number): Observable<Translation[]> {
    const params = { parentID };
    return this.http.get<Translation[]>(`stilLanguageTranslation/getRecordsForParentID`, {
      params
    });
  }

  getRecordsForParentIDWithoutCache(parentID: number): Observable<Translation[]> {
    const params = { parentID };
    return this.http.get<Translation[]>(`stilLanguageTranslation/getRecordsForParentID`, { params: params as any });
  }

  initializeTranslations(languageID: number): Observable<any> {
    const params = {
      languageID
    };
    return this.http.get(`stilLanguageTranslation/initializeTranslations`, { params: params as any });
  }
}
